interface OrderSourceTagProps {
  source?: string | null;
}

export function OrderSourceTag({ source }: OrderSourceTagProps) {
  if (!source?.trim()) return null;

  return (
    <span
      title={`Created from an order on ${source}`}
      className='inline-flex shrink-0 items-center rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-medium leading-4 text-violet-700 ring-1 ring-inset ring-violet-200'
    >
      {source}
    </span>
  );
}
